// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"eaa8e202","358":"2612ef48","388":"746099a2","515":"cedd9ffc","561":"d44865a8","803":"7bc3d500"}[chunkId] + ".chunk.css";
};